"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusionWindowsFilterGroups = void 0;
var ExclusionWindowsFilterGroups;
(function (ExclusionWindowsFilterGroups) {
    ExclusionWindowsFilterGroups["Team"] = "team_id";
})(ExclusionWindowsFilterGroups = exports.ExclusionWindowsFilterGroups || (exports.ExclusionWindowsFilterGroups = {}));
//# sourceMappingURL=exclusion-window.consts.js.map